import { useState } from "react";
import { UserLogsUIProvider } from "./UserLogsUIContext";
import { ExceptionModal } from "./exception-modal/ExceptionModal";
import { UserLogsCard } from "./UserLogsCard";

export function UserLogsPage() {
  const [id, setId] = useState();
  const [showExceptionModal, setShowExceptionModal] = useState();
  const closeExceptionModal = () => setShowExceptionModal(false);

  const userLogsUIEvents = {
    openExceptionModal: (id) => {
      setId(id);
      setShowExceptionModal(true);
    }
  };

  return (
    <UserLogsUIProvider userLogsUIEvents={userLogsUIEvents}>
      <ExceptionModal
        id={id}
        showExceptionModal={showExceptionModal}
        closeExceptionModal={closeExceptionModal}
      />
      <UserLogsCard />
    </UserLogsUIProvider>
 );
}